import React from 'react';
import { motion } from "framer-motion";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import "../modal/modal.scss"

const Modal = ({ isOpen, closeModal, wine }) => {
    return (
        <motion.div
            className={`modal ${isOpen ? 'open' : ''}`}
            initial={{ opacity: 0, scale: 0.5 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
        >
            <motion.div
                className="modal-nav"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.2, ease: "easeOut", delay: 0.2 }}
            >
                <CloseOutlinedIcon onClick={closeModal} />
            </motion.div>
            <div className="modal-content">
                <img src={`https://api.weinkeller.site/uploads/${wine.img}`} alt="Weinfoto" />
            </div>
        </motion.div>
    );
};

export default Modal;
